/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From each colour's relative luminance: (lighter + 0.05) ÷ (darker + 0.05). Luminance weights red, green and blue by how the eye perceives them.`)
};

const es_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partir de la luminancia relativa de cada color: (más claro + 0,05) ÷ (más oscuro + 0,05). La luminancia pondera el rojo, verde y azul según cómo los percibe el ojo.`)
};

const de_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus der relativen Leuchtdichte jeder Farbe: (heller + 0,05) ÷ (dunkler + 0,05). Die Leuchtdichte gewichtet Rot, Grün und Blau danach, wie das Auge sie wahrnimmt.`)
};

const nl_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op basis van de relatieve helderheid van elke kleur: (lichtste + 0,05) ÷ (donkerste + 0,05). Helderheid weegt rood, groen en blauw naar hoe het oog ze waarneemt.`)
};

const fr_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À partir de la luminance relative de chaque couleur : (la plus claire + 0,05) ÷ (la plus foncée + 0,05). La luminance pondère le rouge, le vert et le bleu selon leur perception par l'œil.`)
};

const it_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalla luminanza relativa di ciascun colore: (più chiaro + 0,05) ÷ (più scuro + 0,05). La luminanza pesa rosso, verde e blu in base a come li percepisce l'occhio.`)
};

const pt_br2_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partir da luminância relativa de cada cor: (mais clara + 0,05) ÷ (mais escura + 0,05). A luminância pondera vermelho, verde e azul conforme a percepção do olho humano.`)
};

const pt_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partir da luminância relativa de cada cor: (mais clara + 0,05) ÷ (mais escura + 0,05). A luminância pondera o vermelho, o verde e o azul consoante a forma como o olho os percebe.`)
};

const ja_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各色の相対輝度から算出されます: (明るいほう + 0.05) ÷ (暗いほう + 0.05)。輝度は、目が赤・緑・青をどう知覚するかに応じて重み付けされます。`)
};

const zh_cc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于两种颜色各自的相对亮度：（较亮者 + 0.05）÷（较暗者 + 0.05）。亮度计算会按人眼对红、绿、蓝的感知程度加权。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq_a3", locale)
	if (locale === "en") return en_cc_faq_a3(inputs)
	if (locale === "es") return es_cc_faq_a3(inputs)
	if (locale === "de") return de_cc_faq_a3(inputs)
	if (locale === "nl") return nl_cc_faq_a3(inputs)
	if (locale === "fr") return fr_cc_faq_a3(inputs)
	if (locale === "it") return it_cc_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq_a3(inputs)
	if (locale === "pt") return pt_cc_faq_a3(inputs)
	if (locale === "ja") return ja_cc_faq_a3(inputs)
	return zh_cc_faq_a3(inputs)
};